import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CarouselIndexDirective } from '@directives/carousel-index.directive';
import { CarouselNavigationComponent } from '@modules/shared/carousel-navigation/carousel-navigation.component';
import { CarouselNavigationMode } from '@shared/models/enums/carousel-navigation-mode.enum';
import { QuickModulesComponent } from '@shared/quick-actions/components/quick-modules/quick-modules.component';
import { TuiCarousel } from '@taiga-ui/core';
import { SequenceMediaComponent } from '../sequence-media/sequence-media.component';
import { SequencePreviewMediaCarouselComponent } from './sequence-preview-media-carousel.component';

@Component({
  selector: 'pxc-sequence-preview-tile-media-carousel',
  imports: [
    CommonModule,
    CarouselIndexDirective,
    TuiCarousel,
    DragDropModule,
    CarouselNavigationComponent,
    SequenceMediaComponent,
    QuickModulesComponent,
  ],
  host: {
    class: 'relative aspect-square w-full overflow-hidden rounded-sm bg-background-tertiary shadow shadow-black/5',
  },
  templateUrl: './sequence-preview-tile-media-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SequencePreviewTileMediaCarouselComponent extends SequencePreviewMediaCarouselComponent {
  CarouselNavigationMode = CarouselNavigationMode;

  override thumbnailsPerPage = 1;
}
